import {I18n} from '@aws-amplify/core';
import {Badge} from '@mantine/core';

import {Customer} from '../types';

/**
 * FNP-918: the `delinquent` flag as a badge rather than a raw boolean (§13).
 *
 * ⚠️ Colour is NOT the only carrier of meaning — the badge always renders text
 * ("Delinquent" / "Current"), so it survives a colourblind reader and a
 * greyscale print (§13 Accessibility).
 *
 * Colours are Mantine THEME TOKENS ('red' / 'green'), not hex literals, so both
 * light and dark themes work (§2). The sibling badges in this app
 * (invoices/profile/StatusBadge.tsx and four others) hardcode hex values like
 * '#dc3545' and are non-compliant on that box — they are out of scope for this
 * module and left alone, but do NOT copy them.
 *
 * `delinquent` is nullable. Absent is treated as not-delinquent, which is what
 * Stripe means by it, rather than rendering a third "unknown" state that has no
 * business meaning here.
 */
export const DelinquentBadge = ({record}: {record: Customer}) => {
    const delinquent = record.delinquent === true;

    return (
        <Badge
            color={delinquent ? 'red' : 'green'}
            variant='light'
        >
            {delinquent ? I18n.get('Delinquent') : I18n.get('Current')}
        </Badge>
    );
};
